import Fieldset from "components/form/Fieldset";
import FormContent from "components/form/FormContent";
import GeolocationButton from "components/form/input/GeolocationButton";
import ImageInput from "components/form/input/ImageInput";
import ListInput from "components/form/input/ListInput";
import TextInput from "components/form/input/TextInput";
import { useCoordinates } from "util/geolocation";

export default function ApontamentoColetas({ visita, name = "coletas", label = "Coletas", showList = true, children }) {
    const [coordinates, error] = useCoordinates();
    console.log("Erro ao pegar as coordenadas -> ", error);
    function onAdd(item) {
        item.georeferencia = coordinates;
    }

    function onRemove(item) {
        if (item.image) {
            handleRemoveImage(item.image);
        }
    }

    function handleRemoveImage(image) {
        if (image.uid) {
            visita.deleteImage(image.uid);
        }
    }

    return showList ? (
        <ListInput name={name} label={label} onAdd={onAdd} onRemove={onRemove} fullWidth>
            {children}

            <TextInput name="observacao" label="Observação" />
            <ImageInput name="image" label="Foto" onRemove={handleRemoveImage} small />
            {/* <CheckboxInput name="confirmaRelatorio" label="Relatório" /> */}
            <GeolocationButton name="georeferencia" label="Rota Maps" icon />
        </ListInput>
    ) : (
        <Fieldset label={label}>
            <FormContent>{children}</FormContent>
        </Fieldset>
    );
}
